module.exports = __webpack_public_path__ + "img/login-bg2.e7809934.jpg";